/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { elementInViewport } from '../../utils/dom.mjs';
import '../../_chunks/dep-a48de419.mjs';
import '../../_chunks/dep-2684fd15.mjs';
import '../../_chunks/dep-3ca5fb38.mjs';
import '../../_chunks/dep-7071345f.mjs';
import '../../_chunks/dep-3d4aad09.mjs';
import '../../_chunks/dep-c27b1c14.mjs';
import '../../utils/easing.mjs';

function getScrollParent(element) {
  var style = window.getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRegex = /(auto|scroll)/;
  if (style.position === "fixed") return document.body;

  for (var parent = element; parent.parentElement;) {
    parent = parent.parentElement;
    style = window.getComputedStyle(parent);

    if (excludeStaticParent && style.position === "static") {
      continue;
    }

    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
  }

  return document.body;
}
function scrollToParentVisibleArea(element) {
  var parent = getScrollParent(element);
  if (parent === document.body) return;
  if (elementInViewport(element, parent)) return;
  parent.scrollTop = element.offsetTop - parent.offsetTop;
}

export { getScrollParent, scrollToParentVisibleArea };
//# sourceMappingURL=getScrollParent.mjs.map
